import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export type PartnerType = 'Distributor' | 'Retail'

export class PartnerGroupApi {
  public static fetchPartnerGroup = async (
    partnerId: string,
    fyear: number,
    partnerType: PartnerType
  ) => {
    const url = proxy('/webservice/1149/sp/v3/spJBPPartnerGroup/call')
    const payload = {
      'p.PartnerId': partnerId,
      'p.FYear': fyear,
      'p.PartnerType': partnerType,
    }

    const { app } = appGetState()
    const [accessToken] = await getTokens(app.ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    const response = await Rest.post({ url, payload, headers })

    return response
  }
}
